/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetUserListQueryResponse,
  GetUserListQueryParams,
  GetUserList500,
} from "../types/GetUserList.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUserListQueryKey = (params?: GetUserListQueryParams) =>
  [{ url: "/user/list" }, ...(params ? [params] : [])] as const;

export type GetUserListQueryKey = ReturnType<typeof getUserListQueryKey>;

/**
 * @description Если search не указан, возвращаются все пользователи с применением фильтров и сортировки.
 * @summary Получение списка всех пользователей с фильтрацией и сортировкой
 * {@link /user/list}
 */
export async function getUserList(
  params?: GetUserListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetUserListQueryResponse,
    ResponseErrorConfig<GetUserList500>,
    unknown
  >({ method: "GET", url: `/user/list`, params, ...requestConfig });
  return res;
}

export function getUserListQueryOptions(
  params?: GetUserListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getUserListQueryKey(params);
  return queryOptions<
    ResponseConfig<GetUserListQueryResponse>,
    ResponseErrorConfig<GetUserList500>,
    ResponseConfig<GetUserListQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserList(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Если search не указан, возвращаются все пользователи с применением фильтров и сортировки.
 * @summary Получение списка всех пользователей с фильтрацией и сортировкой
 * {@link /user/list}
 */
export function useGetUserList<
  TData = ResponseConfig<GetUserListQueryResponse>,
  TQueryData = ResponseConfig<GetUserListQueryResponse>,
  TQueryKey extends QueryKey = GetUserListQueryKey,
>(
  params?: GetUserListQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetUserListQueryResponse>,
        ResponseErrorConfig<GetUserList500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getUserListQueryKey(params);

  const query = useQuery(
    {
      ...getUserListQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUserList500>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
